import FantasyTeam from '../FantasyTeam';

export class TradeTeam extends FantasyTeam {
	setPlayersAvailableForSwap() {
		const empty_positions = this.empty_positions;

		this.eachPlayer(player => {
			player.can_be_swapped = player.positions.some(
				pos => empty_positions.includes('bench') || empty_positions.includes(pos)
			);
		});

		return this;
	}

	setTradeLockState(should_be_locked) {
		this.eachPlayer(player => player.is_trade_locked = should_be_locked);

		return this;
	}
}

export default TradeTeam;